import { defineStore } from 'pinia'
import API from '@/api/apiUrls'
import type { ShiptypeType } from '@/stores/type/shipType.type'
import { useApi } from '@/api/useApi'
import { useBaseStore } from '@haskoning/vue-basestore'

const api = useApi<ShiptypeType>()

const baseUrl = API.SHIP_TYPE.BASE

export const useShipTypeStore = defineStore('shipType', () => {
	const baseStore = useBaseStore<ShiptypeType>({ service: baseUrl, api })
	const resetAll = () => {
		baseStore.reset()
	}

	return {
		...baseStore,
		resetAll
	}
})
